import React from 'react';

import { SvgWrapper } from 'components/svgs/SvgWrapper/SvgWrapper';

export const TrashSvg = ({ ...svgProps }) => (
  <SvgWrapper viewBox="0 0 12 12" {...svgProps}>
    <path d="M3.5 3V2C3.5 1.44772 3.94772 1 4.5 1H7.5C8.05228 1 8.5 1.44772 8.5 2V3H10.5C10.7761 3 11 3.22386 11 3.5C11 3.77614 10.7761 4 10.5 4H10V10C10 10.5523 9.55229 11 9 11H3C2.44772 11 2 10.5523 2 10V4H1.5C1.22386 4 1 3.77614 1 3.5C1 3.22386 1.22386 3 1.5 3H3.5ZM4.5 3H7.5V2H4.5V3ZM9 4H3V10H9V4ZM5 5C5.27614 5 5.5 5.22386 5.5 5.5V8.5C5.5 8.77614 5.27614 9 5 9C4.72386 9 4.5 8.77614 4.5 8.5V5.5C4.5 5.22386 4.72386 5 5 5ZM7 5C7.27614 5 7.5 5.22386 7.5 5.5V8.5C7.5 8.77614 7.27614 9 7 9C6.72386 9 6.5 8.77614 6.5 8.5V5.5C6.5 5.22386 6.72386 5 7 5Z" />
  </SvgWrapper>
);
